import { ACCESS_LEVEL } from '~/constants/_core/access-level';
import { OWNER } from '~/constants/_core/owner';
import { SAFEA_V3_ENABLED } from '~/constants/_core/safea-v3';

export default {
  getCurrentAccessLevel: (user, _, rootState) =>{
    if (SAFEA_V3_ENABLED) {
      if (user.currentContext.institution?.uuid) {
        return ACCESS_LEVEL.INSTITUTION;
      }

      if (user.currentContext.tenant?.uuid) {
        return ACCESS_LEVEL.TENANT;
      }

      return ACCESS_LEVEL.APPLICATION;
    }

    const currentRole = rootState._core.auth.currentRole;
    if (currentRole.ies.id) {
      return ACCESS_LEVEL.INSTITUTION;
    }

    if (currentRole.tenant.id) {
      return ACCESS_LEVEL.TENANT;
    }

    return ACCESS_LEVEL.APPLICATION;
  },
  canAccessCurrentContext: (user) => {
    return Object.keys(user.permissions ?? {}).length > 0;
  },
  canAccessAtLeastOneContext: (user, _, rootState) => {
    const owner = rootState._core.application.owner;
    const tenantUuid = rootState._core.tenant?.uuid;
    const institutionUuid = rootState._core.tenant?.institution?.uuid;

    if (owner === OWNER.IES) {
      if (!institutionUuid) {
        throw new Error('[Cockpit] The hostname endpoint returned no institution UUID despite having an "ies" owner');
      }

      const tenant = user.contexts.find(ctx => ctx.level === ACCESS_LEVEL.TENANT && ctx.uuid === tenantUuid);
      return tenant.institutions.some(institution => institution.uuid === institutionUuid);
    }

    if (owner === OWNER.TENANT) {
      if (!tenantUuid) {
        throw new Error('[Cockpit] The hostname endpoint returned no tenant UUID despite having a "tenant" owner');
      }

      return user.contexts.some(ctx => ctx.level === ACCESS_LEVEL.TENANT && ctx.uuid === tenantUuid);
    }

    return user.contexts.length > 0;
  },
  canChangePassword: (user, getters, rootState) => {
    if (SAFEA_V3_ENABLED) {
      return user.amr.includes('pwd');
    }
    return !['sso', 'saml'].includes(rootState._core.auth.authMode?.toLowerCase());
  },
  // deprecated
  dark: user => user.dark,

  //Note: Não remover o getter abaixo, até finalizar a refatoração dos locais onde são utilizados
  getName   : user => user.name,
  getEmail  : user => user.email,
  getUserId : user => user.id
};
